<template>
  <footer class="light">
    <div class="container">
      <div class="row">
        <div class="col-lg-4">
          <h3>
            <img :src="require('Assets/images/logo2.png')" alt="">
          </h3>
          <br>
          <div class="icon-links icon-social icon-links-grid social-colors">
            <a href="http://www.facebook.com/skysolardistribuidora" class="facebook"><i
              class="icon-facebook"></i></a>
            <a href="http://www.linkedin.com/skysolardistribuidora" class="linkedin"><i
              class="icon-linkedin"></i></a>
            <a href="http://www.instagram.com/skysolardistribuidora" class="instagram"><i
              class="icon-instagram"></i></a>
            <a href="https://api.whatsapp.com/send?phone=554430520044&text=Ol%C3%A1!%20"
               style="background-color: #39ad18; border-color: #39ad18; color: #FFF;"
               class="whatsapp"><i class="fab fa-whatsapp"></i>
            </a>
          </div>
          <br>
          <img :src="require('Assets/images/absolar.png')" alt="">
        </div>
        <div class="col-lg-4">
          <h3>Links Rápidos</h3>
          <ul class="icon-list icon-line">
            <li><router-link to="/contato">Fale Conosco</router-link></li>
            <li><a href="https://piedskysolar.skygroupbr.com">Portal do Cliente</a></li>
            <li><a href="#">Termos de Uso</a></li>
            <li><a href="#">Termos de Atendimento</a></li>
            <li><a href="#">Política de Privacidade</a></li>
            <li><a href="#">Condições Comerciais</a></li>
            <li><a href="#">Venda Direta</a></li>
            <li><a href="#">Código de Conduta e Ética</a></li>
          </ul>
        </div>
        <div class="col-lg-4">
          <ul class="text-list text-list-line">
            <li><b>Localização</b>
              <hr/>
              <p></p></li>
            <li><p>Av. Melvin Jones 440</p></li>
            <li><p>Jardim Bandeirantes - Maringá - PR</p></li>
            <li><p>CEP 87070-030</p></li>
            <li><b>Email</b>
              <hr/>
              <p>contato@skysolar.com.br</p></li>
            <li><b>Telefone/WhatsApp</b>
              <hr/>
              <p>(44) 3052-0044</p></li>
            <li><b>Funcionamento</b>
              <hr/>
              <p>8h - 18h de Seg - Sex</p></li>
            <li><b>Para Visitas</b>
              <hr/>
              <p>Verificar Agendamento</p></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bar">
      <div class="container">
        <span>
          {{ new Date().getFullYear() }}© 33.426.806/0001-03 -
          SKY SOLAR SOLUCOES EM ENERGIA SOLAR LTDA
        </span>
        <span>
          <router-link to="/contato">Fale Conosco</router-link>
          | <a href="#">Política de Privacidade</a>
        </span>
      </div>
    </div>
<!--    <link rel="stylesheet" href="themekit/media/icons/iconsmind/line-icons.min.css">-->
<!--    <script src="themekit/scripts/jquery.min.js"></script>-->
<!--    <script src="themekit/scripts/main.js"></script>-->
<!--    <script src="themekit/scripts/parallax.min.js"></script>-->
<!--    <script src="themekit/scripts/glide.min.js"></script>-->
<!--    <script src="themekit/scripts/custom.js"></script>-->
<!--    <script src="themekit/scripts/progress.js"></script>-->
<!--    <script src="themekit/scripts/tab-accordion.js"></script>-->
<!--    <script src="themekit/scripts/magnific-popup.min.js"></script>-->
<!--    <script src="themekit/scripts/imagesloaded.min.js"></script>-->
<!--    <script src="themekit/scripts/contact-form/contact-form.js"></script>-->
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style scoped>

</style>
